export default "/assets/Icon/Play.svg"